import { fromJS } from 'immutable'
import {
  PUBLIC_HOLIDAY_DELETE_REQUEST,
  PUBLIC_HOLIDAY_DELETE_SUCCESS,
  PUBLIC_HOLIDAY_DELETE_FAILURE,
  PUBLIC_HOLIDAY_DELETE_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case PUBLIC_HOLIDAY_DELETE_REQUEST:
      return state
        .set('isFetching', true)
    case PUBLIC_HOLIDAY_DELETE_SUCCESS:
      return state
        .set('isFetching', false)
        .set('deletedHoliday', fromJS(action.payload.deletedHoliday))
        .set('status', 200)
        .set('message', 'Deleted Successfully.')
    case PUBLIC_HOLIDAY_DELETE_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
        .set('deletedHoliday', fromJS(action.payload.message))
        .set('status', 'Error')
        .set('message', fromJS(action.payload.response.message))
    case PUBLIC_HOLIDAY_DELETE_RESET:
      return state
        .delete('deletedHoliday')
        .delete('status')
        .delete('message')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/public-holiday/public-holiday-delete-reducer.js